import { render } from "./e9.p2.direction.vue?vue&type=template&id=1a027fde"
import script from "./e9.p2.direction.vue?vue&type=script&lang=js"
export * from "./e9.p2.direction.vue?vue&type=script&lang=js"

import exportComponent from "/home/cramirez/Documentos/Escuela/IPN/CD-ESFM/Tour/tour/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__